import { reduxForm, Field, isDirty, getFormValues } from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import {ActionBarWrapper} from 'components/wrappers/pages'
import {onChangeOutletIds, onClickCreateModifier} from 'actions/library/modifier'
import {askConfirmAction} from 'actions/confirm-action'
import * as mpLibraryModifier from 'mixpanel/library/modifier'

class ActionBar extends React.Component {
  render () {
    let {outlets} = this.props
    return (<ActionBarWrapper>
      <div className='col-sm-4 col-xs-12' style={{paddingLeft: 0}}>
        <Field
          name='outletIds'
          component={DropdownOutlet}
          outlets={outlets}
          onChangeOutletIds={this._onChangeOutletIds}
          />
      </div>
      <div className='col-sm-8 hidden-xs' style={{paddingRight: 0}}>
        <span className='pull-right'>
          <button className='btn btn-primary' onClick={this._onClickCreateModifier}>
              Create Modifier
            </button>
        </span>
      </div>
    </ActionBarWrapper>)
  }

  _onClickCreateModifier = () => {
    const {dispatch, isDirtyModifier} = this.props
    if (isDirtyModifier) {
      dispatch((askConfirmAction(onClickCreateModifier())))
    } else {
      dispatch(onClickCreateModifier())
    }
  };

  /**
   * Redux form auto convert array to objects, so we change it back to array
   * @private
   * @param outletIdsAsObject
   */
  _onChangeOutletIds = (outletIds) => {
    const {dispatch, isDirtyModifier, searchValue} = this.props
    const prevOutlets = searchValue.outletIds[0]
    mpLibraryModifier.libraryModifierChangeOutlet({prevOutlet: prevOutlets, currOutlet: outletIds})
    if (isDirtyModifier) {
      dispatch(askConfirmAction(onChangeOutletIds(outletIds)))
    } else {
      dispatch(onChangeOutletIds(outletIds))
    }
  };
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  const {outlets} = state.library.modifier
  return {
    outlets,
    isDirtyModifier: isDirty('modifier')(state),
    searchValue: getFormValues('search')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/ActionBar/ActionBar.js